export default __webpack_public_path__ + "static/media/nf.d0dc5e07.svg";